/** Every lazy import in one place, so the same module is never loaded through two paths. */
export const IMPORT_MAP = {
  intl: {
    intl: () => import('intl'),
    // eslint-disable-next-line import/extensions
    localePolyfill: () => import('@formatjs/intl-locale/polyfill.js'),
    // eslint-disable-next-line import/extensions
    pluralRulesPolyfill: () => import('@formatjs/intl-pluralrules/polyfill.js'),
    // eslint-disable-next-line import/extensions
    relativeTimeFormatPolyfill: () => import('@formatjs/intl-relativetimeformat/polyfill.js'),
    LocaleData: {
      ru: () => import('intl/locale-data/jsonp/ru'),
      en: () => import('intl/locale-data/jsonp/en'),
    },
    PluralRules: {
      // eslint-disable-next-line import/extensions
      ru: () => import('@formatjs/intl-pluralrules/locale-data/ru.js'),
      // eslint-disable-next-line import/extensions
      en: () => import('@formatjs/intl-pluralrules/locale-data/en.js'),
    },
    RelativeTimeFormat: {
      // eslint-disable-next-line import/extensions
      ru: () => import('@formatjs/intl-relativetimeformat/locale-data/ru.js'),
      // eslint-disable-next-line import/extensions
      en: () => import('@formatjs/intl-relativetimeformat/locale-data/en.js'),
    },
  },
  utils: {
    addressTools: () => import('@app/utils/addressTools'),
  },
} as const
